import { createRoot } from 'react-dom/client';
import './index.scss';
import { RouterProvider } from 'react-router-dom';
import { router } from './app-site/routeConfig';
import "./i18n";

const container = document.getElementById('root');

if (container) {
    const root = createRoot(container);
    root.render(
        <RouterProvider router={router} />
    );
}
